export const deploymentRolePolicy = {
	"Version": "2012-10-17",
	"Statement": [
		{
			"Sid": "IAMAccess",
			"Effect": "Allow",
			"Action": [
				"iam:CreateRole",
				"iam:PutRolePolicy",
				"iam:AttachRolePolicy",
				"iam:DetachRolePolicy",
				"iam:CreateInstanceProfile",
				"iam:DeleteInstanceProfile",
				"iam:GetInstanceProfile",
				"iam:AddRoleToInstanceProfile",
				"iam:RemoveRoleFromInstanceProfile",
				"iam:ListInstanceProfiles",
				"iam:ListInstanceProfilesForRole",
				"iam:PassRole",
				"iam:GetRole",
				"iam:ListAttachedRolePolicies",
				"iam:ListRolePolicies",
				"iam:GetRolePolicy",
				"iam:GetPolicy",
				"iam:GetPolicyVersion",
				"iam:DeleteRole",
				"iam:UpdateRole"
			],
			"Resource": [
				"arn:aws:iam::*:role/*",
				"arn:aws:iam::*:instance-profile/*",
				"arn:aws:iam::*:policy/*"
			]
		},
		{
			"Sid": "S3Access",
			"Effect": "Allow",
			"Action": [
				"s3:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "EC2Access",
			"Effect": "Allow",
			"Action": [
				"ec2:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "ECSAccess",
			"Effect": "Allow",
			"Action": [
				"ecs:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "SecretsManagerAccess",
			"Effect": "Allow",
			"Action": [
				"secretsmanager:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "CodePipelineAccess",
			"Effect": "Allow",
			"Action": [
				"codepipeline:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "CodeDeployAccess",
			"Effect": "Allow",
			"Action": [
				"codedeploy:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "CodeBuildAccess",
			"Effect": "Allow",
			"Action": [
				"codebuild:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "ECRAccess",
			"Effect": "Allow",
			"Action": [
				"ecr:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "STSAccess",
			"Effect": "Allow",
			"Action": [
				"sts:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "SSMAccess",
			"Effect": "Allow",
			"Action": [
				"ssm:*",
				"ec2:DescribeInstanceStatus",
				"ec2:DescribeInstances",
				"ec2messages:*",
				"ssmmessages:*"
			],
			"Resource": "*"
		},
		{
			"Sid": "CloudWatchMonitoringAccess",
			"Effect": "Allow",
			"Action": [
				"cloudwatch:PutMetricAlarm",
				"cloudwatch:DeleteAlarms",
				"cloudwatch:DescribeAlarms",
				"cloudwatch:DescribeAlarmsForMetric",
				"cloudwatch:GetMetricStatistics",
				"cloudwatch:ListMetrics",
				"cloudwatch:PutMetricData",
				"cloudwatch:EnableAlarmActions",
				"cloudwatch:DisableAlarmActions",
				"cloudwatch:SetAlarmState",
				"cloudwatch:DescribeAlarmHistory",
				"cloudwatch:PutDashboard",
				"cloudwatch:GetDashboard",
				"cloudwatch:DeleteDashboards",
				"cloudwatch:ListDashboards",
				"cloudwatch:PutCompositeAlarm",
				"cloudwatch:DescribeAnomalyDetectors",
				"cloudwatch:PutAnomalyDetector"
			],
			"Resource": "*"
		},
		{
			"Sid": "CloudWatchLogsAccess",
			"Effect": "Allow",
			"Action": [
				"logs:CreateLogGroup",
				"logs:CreateLogStream",
				"logs:PutLogEvents",
				"logs:DescribeLogGroups",
				"logs:DescribeLogStreams",
				"logs:GetLogEvents",
				"logs:FilterLogEvents",
				"logs:PutSubscriptionFilter",
				"logs:DeleteSubscriptionFilter",
				"logs:DescribeSubscriptionFilters",
				"logs:PutRetentionPolicy",
				"logs:DeleteLogGroup",
				"logs:DeleteLogStream",
				"logs:PutMetricFilter",
				"logs:DeleteMetricFilter",
				"logs:DescribeMetricFilters"
			],
			"Resource": [
				"arn:aws:logs:*:*:log-group:/aws/ec2/*",
				"arn:aws:logs:*:*:log-group:qixdeploy*",
				"arn:aws:logs:*:*:log-group:/aws/lambda/*",
				"arn:aws:logs:*:*:log-group:/aws/ecs/*",
				"arn:aws:logs:*:*:log-group:/aws/codebuild/*"
			]
		},
		{
			"Sid": "SNSAlertingAccess",
			"Effect": "Allow",
			"Action": [
				"sns:CreateTopic",
				"sns:DeleteTopic",
				"sns:Subscribe",
				"sns:Unsubscribe",
				"sns:Publish",
				"sns:ListTopics",
				"sns:ListSubscriptions",
				"sns:ListSubscriptionsByTopic",
				"sns:GetTopicAttributes",
				"sns:SetTopicAttributes",
				"sns:AddPermission",
				"sns:RemovePermission",
				"sns:ConfirmSubscription",
				"sns:GetSubscriptionAttributes",
				"sns:SetSubscriptionAttributes"
			],
			"Resource": [
				"arn:aws:sns:*:*:qixdeploy*",
				"arn:aws:sns:*:*:*-alerts",
				"arn:aws:sns:*:*:monitoring*"
			]
		},
		{
			"Sid": "AutoScalingAccess",
			"Effect": "Allow",
			"Action": [
				"autoscaling:CreateAutoScalingGroup",
				"autoscaling:UpdateAutoScalingGroup",
				"autoscaling:DeleteAutoScalingGroup",
				"autoscaling:DescribeAutoScalingGroups",
				"autoscaling:DescribeAutoScalingInstances",
				"autoscaling:SetDesiredCapacity",
				"autoscaling:TerminateInstanceInAutoScalingGroup",
				"autoscaling:PutScalingPolicy",
				"autoscaling:DeletePolicy",
				"autoscaling:DescribePolicies",
				"autoscaling:ExecutePolicy",
				"autoscaling:PutLifecycleHook",
				"autoscaling:DeleteLifecycleHook",
				"autoscaling:DescribeLifecycleHooks",
				"autoscaling:CompleteLifecycleAction",
				"autoscaling:RecordLifecycleActionHeartbeat",
				"autoscaling:CreateOrUpdateTags",
				"autoscaling:DeleteTags",
				"autoscaling:DescribeTags",
				"autoscaling:DescribeScalingActivities",
				"autoscaling:DescribeScheduledActions",
				"autoscaling:PutScheduledUpdateGroupAction",
				"autoscaling:DeleteScheduledAction",
				"autoscaling:EnableMetricsCollection",
				"autoscaling:DisableMetricsCollection",
				"autoscaling:SuspendProcesses",
				"autoscaling:ResumeProcesses"
			],
			"Resource": "*"
		},
		{
			"Sid": "ApplicationAutoScalingAccess",
			"Effect": "Allow",
			"Action": [
				"application-autoscaling:RegisterScalableTarget",
				"application-autoscaling:DeregisterScalableTarget",
				"application-autoscaling:DescribeScalableTargets",
				"application-autoscaling:PutScalingPolicy",
				"application-autoscaling:DeleteScalingPolicy",
				"application-autoscaling:DescribeScalingPolicies",
				"application-autoscaling:DescribeScalingActivities",
				"application-autoscaling:PutScheduledAction",
				"application-autoscaling:DeleteScheduledAction",
				"application-autoscaling:DescribeScheduledActions"
			],
			"Resource": "*"
		},
		{
			"Sid": "LaunchTemplateAccess",
			"Effect": "Allow",
			"Action": [
				"ec2:CreateLaunchTemplate",
				"ec2:CreateLaunchTemplateVersion",
				"ec2:DeleteLaunchTemplate",
				"ec2:DeleteLaunchTemplateVersions",
				"ec2:DescribeLaunchTemplates",
				"ec2:DescribeLaunchTemplateVersions",
				"ec2:GetLaunchTemplateData",
				"ec2:ModifyLaunchTemplate"
			],
			"Resource": "*"
		},
		{
			"Sid": "LoadBalancerAccess",
			"Effect": "Allow",
			"Action": [
				"elasticloadbalancing:CreateLoadBalancer",
				"elasticloadbalancing:DeleteLoadBalancer",
				"elasticloadbalancing:DescribeLoadBalancers",
				"elasticloadbalancing:DescribeLoadBalancerAttributes",
				"elasticloadbalancing:ModifyLoadBalancerAttributes",
				"elasticloadbalancing:CreateTargetGroup",
				"elasticloadbalancing:DeleteTargetGroup",
				"elasticloadbalancing:DescribeTargetGroups",
				"elasticloadbalancing:DescribeTargetHealth",
				"elasticloadbalancing:RegisterTargets",
				"elasticloadbalancing:DeregisterTargets",
				"elasticloadbalancing:ModifyTargetGroup",
				"elasticloadbalancing:ModifyTargetGroupAttributes",
				"elasticloadbalancing:DescribeTargetGroupAttributes",
				"elasticloadbalancing:CreateListener",
				"elasticloadbalancing:DeleteListener",
				"elasticloadbalancing:DescribeListeners",
				"elasticloadbalancing:ModifyListener",
				"elasticloadbalancing:CreateRule",
				"elasticloadbalancing:DeleteRule",
				"elasticloadbalancing:DescribeRules",
				"elasticloadbalancing:ModifyRule",
				"elasticloadbalancing:AddTags",
				"elasticloadbalancing:RemoveTags",
				"elasticloadbalancing:DescribeTags"
			],
			"Resource": "*"
		},
		{
			"Sid": "CloudWatchAgentAccess",
			"Effect": "Allow",
			"Action": [
				"ssm:GetParameter",
				"ssm:GetParameters",
				"ssm:PutParameter",
				"ssm:DeleteParameter",
				"ssm:DescribeParameters",
				"ssm:GetParameterHistory",
				"ssm:GetParametersByPath"
			],
			"Resource": [
				"arn:aws:ssm:*:*:parameter/AmazonCloudWatch-*",
				"arn:aws:ssm:*:*:parameter/qixdeploy/*"
			]
		},
		{
			"Sid": "EventBridgeAccess",
			"Effect": "Allow",
			"Action": [
				"events:PutRule",
				"events:DeleteRule",
				"events:DescribeRule",
				"events:EnableRule",
				"events:DisableRule",
				"events:ListRules",
				"events:PutTargets",
				"events:RemoveTargets",
				"events:ListTargetsByRule"
			],
			"Resource": [
				"arn:aws:events:*:*:rule/qixdeploy*",
				"arn:aws:events:*:*:rule/*monitoring*",
				"arn:aws:events:*:*:rule/*autoscaling*"
			]
		},
		{
			"Sid": "LambdaAccess",
			"Effect": "Allow",
			"Action": [
				"lambda:CreateFunction",
				"lambda:DeleteFunction",
				"lambda:GetFunction",
				"lambda:ListFunctions",
				"lambda:UpdateFunctionCode",
				"lambda:UpdateFunctionConfiguration",
				"lambda:InvokeFunction",
				"lambda:AddPermission",
				"lambda:RemovePermission",
				"lambda:GetPolicy",
				"lambda:CreateEventSourceMapping",
				"lambda:DeleteEventSourceMapping",
				"lambda:GetEventSourceMapping",
				"lambda:ListEventSourceMappings",
				"lambda:UpdateEventSourceMapping"
			],
			"Resource": [
				"arn:aws:lambda:*:*:function:qixdeploy*",
				"arn:aws:lambda:*:*:function:*monitoring*",
				"arn:aws:lambda:*:*:function:*autoscaling*"
			]
		},
		{
			"Sid": "BackupAccess",
			"Effect": "Allow",
			"Action": [
				"backup:CreateBackupPlan",
				"backup:DeleteBackupPlan",
				"backup:GetBackupPlan",
				"backup:ListBackupPlans",
				"backup:UpdateBackupPlan",
				"backup:CreateBackupSelection",
				"backup:DeleteBackupSelection",
				"backup:GetBackupSelection",
				"backup:ListBackupSelections",
				"backup:StartBackupJob",
				"backup:StopBackupJob",
				"backup:DescribeBackupJob",
				"backup:ListBackupJobs",
				"backup:StartRestoreJob",
				"backup:DescribeRestoreJob",
				"backup:ListRestoreJobs"
			],
			"Resource": "*"
		},
		{
			"Sid": "CloudFormationAccess",
			"Effect": "Allow",
			"Action": [
				"cloudformation:CreateStack",
				"cloudformation:UpdateStack",
				"cloudformation:DeleteStack",
				"cloudformation:DescribeStacks",
				"cloudformation:DescribeStackEvents",
				"cloudformation:DescribeStackResources",
				"cloudformation:GetTemplate",
				"cloudformation:ListStacks",
				"cloudformation:ValidateTemplate",
				"cloudformation:CreateChangeSet",
				"cloudformation:DeleteChangeSet",
				"cloudformation:DescribeChangeSet",
				"cloudformation:ExecuteChangeSet",
				"cloudformation:ListChangeSets"
			],
			"Resource": [
				"arn:aws:cloudformation:*:*:stack/qixdeploy*",
				"arn:aws:cloudformation:*:*:changeSet/qixdeploy*"
			]
		},
		{
			"Sid": "TaggingAccess",
			"Effect": "Allow",
			"Action": [
				"tag:GetResources",
				"tag:TagResources",
				"tag:UntagResources",
				"tag:GetTagKeys",
				"tag:GetTagValues"
			],
			"Resource": "*"
		},
		{
			"Sid": "CostExplorerAccess",
			"Effect": "Allow",
			"Action": [
				"ce:GetCostAndUsage",
				"ce:GetDimensionValues",
				"ce:GetReservationCoverage",
				"ce:GetReservationPurchaseRecommendation",
				"ce:GetReservationUtilization",
				"ce:ListCostCategoryDefinitions"
			],
			"Resource": "*"
		}
	]
}